module.exports = __webpack_public_path__ + "resources/img/img_voice_studio2_m.9e9f788fdeaf9c93d8ac5e6b02b9c80b.png";